/* Keep the hidden content measurable so it can reappear after a resize.
   CSS visibility + inert remove hidden links from keyboard/accessibility use.
   The sibling JSON-LD is independent of this visual decision. */
if (!customElements.get('k9-breadcrumb-fit')) {
  customElements.define('k9-breadcrumb-fit', class extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-k9-breadcrumbs]');
      this.list = this.nav?.querySelector('ol');
      if (!this.list) return;

      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.observer.observe(this.list);
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.schedule();
      });
      this.schedule();
    }

    measure() {
      const available = this.nav.getBoundingClientRect().width;
      const required = this.list.getBoundingClientRect().width;
      const fits = available > 0 && required <= available;
      if (this.dataset.fit === String(fits)) return;
      this.dataset.fit = String(fits);
      this.inert = !fits;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
